import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { BlockDescriptiveImage } from "@/views/blocks/PageBlock.interface";
import { handleHashNavigation } from "@/shared/utils/router/hashNavigation";
import Image from "@/views/blocks/shared/section/media/image/Image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoComponent',
  props: {
    alt: {},
    src: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    "aria-label": "Scroll to top",
    class: "min-w-fit rounded-lg",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleHashNavigation) && _unref(handleHashNavigation)(...args)))
  }, [
    _createVNode(Image, {
      class: "h-8 w-auto",
      src: _ctx.src,
      alt: _ctx.alt,
      width: "142",
      height: "32"
    }, null, 8, ["src", "alt"])
  ]))
}
}

})